document.querySelectorAll('[data-bookids-image]').forEach(el=>{el.src=window.bookidsAssets[el.dataset.bookidsImage]});document.querySelectorAll('[data-bookids-video]').forEach(el=>{el.src=window.bookidsAssets[el.dataset.bookidsVideo];el.poster=window.bookidsAssets[el.dataset.bookidsPoster]});document.querySelector('[data-variant-select]')?.addEventListener('change',e=>{const o=e.target.selectedOptions[0],b=document.querySelector('[data-add-button]');document.querySelector('[data-product-price]').textContent=o.dataset.price;b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?b.dataset.sold:b.dataset.add;const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState({},'',u)});

function bookidsUpdateEdition(select) {
  const edition = select.matches('[data-variant-select]')
    ? select.selectedOptions[0]?.dataset.bookidsEdition
    : ({'Türkçe': 'tr', 'Turkish': 'tr', 'English': 'en', 'İngilizce': 'en'})[select.value];
  const section = select.closest('.commerce');
  const media = section?.querySelector('[data-bookids-product-media]');
  if (!edition || !media) return;
  section.querySelectorAll('[data-bookids-edition-panel]').forEach(panel => {
    panel.hidden = panel.dataset.bookidsEditionPanel !== edition;
    if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
  });
  const source = edition === 'tr' ? media.dataset.imageTr : media.dataset.imageEn;
  const image = media.querySelector('.product-photo');
  if (!source || !image) return;
  const url = new URL(source, document.baseURI);
  image.sizes = '(max-width: 800px) 90vw, (max-width: 1280px) 45vw, 580px';
  image.srcset = [240, 352, 480, 640, 800, 1200, 1600].map(width => {
    const candidate = new URL(url);
    candidate.searchParams.set('width', String(width));
    return candidate.href + ' ' + width + 'w';
  }).join(', ');
  image.src = url.href;
}
document.addEventListener('change', event => {
  if (event.target.matches('#BookidsBookLanguage, [data-variant-select]')) {
    bookidsUpdateEdition(event.target);
  }
});
const bookidsRestoreEdition = () => {
  document.querySelectorAll('#BookidsBookLanguage, [data-variant-select]').forEach(bookidsUpdateEdition);
};
window.addEventListener('pageshow', bookidsRestoreEdition);
document.addEventListener('shopify:section:load', bookidsRestoreEdition);
bookidsRestoreEdition();

